module.exports = __webpack_public_path__ + "img/12.a9c6029e.png";